/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'myUnderScore',
    pure: false,
})

export class UnderScorePipe implements PipeTransform {

    /**
     *
     * @param {string} value
     * @returns {any}
     */
    public transform(value: string): any {
        if (!value) {
            return '';
        }

        return value.replace(/-/g, '_');
    }
}
